import { FunctionComponent, useEffect, useState } from 'react';
import { ICard } from '@belong/types';
import { CardBusy, CardContent, CardWrapper, LinearProgress } from './Card.styles';

/**
 * Providing Card layout for a form with busy state.
 */
export const Card: FunctionComponent<ICard> = ({
  isBusy,
  children,
  disabled,
  duration,
  startTime,
  containsForm = true,
  ...otherProps
}: ICard) => {
  const isDeterminate = duration !== undefined && startTime !== undefined;
  const [completed, setCompleted] = useState(0.1);

  useEffect((): any | void => {
    if (isDeterminate && isBusy) {
      const id = setInterval(() => {
        setCompleted(((new Date().getTime() - startTime) / duration) * 100);
      }, 20); // ≈ 50fps
      return () => {
        setCompleted(0.1);
        clearInterval(id);
      };
    }
  }, [isDeterminate, isBusy, startTime, duration]);

  return (
    <CardWrapper containsForm={containsForm} {...otherProps}>
      <CardBusy>{isBusy && <LinearProgress completed={isDeterminate ? completed : undefined} />}</CardBusy>
      <CardContent disabled={disabled}>{children}</CardContent>
    </CardWrapper>
  );
};

Card.displayName = 'Card';
